<template>
    <div class="card" v-on:click="resultsClicked('' + photo)">
        <div class="header-section text-left"> 
            <span>
                <img :src="displayImg" class="display-image" />
                
                <img v-if="gold === true" src="../assets/gold_full.svg" class="medal"/>
                <img v-else-if="silver === true" src="../assets/silver_full.svg" class="medal"/>
                <img v-else-if="bronze === true" src="../assets/bronze_full.svg" class="medal"/> 
                <img v-else src="" class="medal-special" /> 
                <b-button class="upvotes-display">{{upvotes}}<span class="span-caret">&#x25B4;</span></b-button>
                      
                
                       
            </span>
        </div>
        <div class="bottom-panel text-left">
            <span><img :src="photo" class="photo"/>{{name}}</span>
        </div>
    </div>
</template>


<script>
export default {
    name: 'ResultsCard',
    props: {
        photo: String,
        name: String,
        upvotes: Number,
        gold: Boolean,
        silver: Boolean,
        bronze: Boolean,
        displayImg: String,
    },
    methods: {
        resultsClicked: function(photo) {
            this.$emit('results_card_clicked', photo);
        }
    }
}
</script>


<style scoped>
.card {
    margin-top:20px; 
    margin-bottom:20px; 
    width:100%;
    border:none;
    box-shadow: 4px 2px 4px 0px rgba(46,61,73,0.15);
    transition: all 0.3s ease;
    font-family: Helvetica;
    cursor:pointer;
    background-color:#fff;
    color:#333;
    display:inline-block;
}

.medal {
    width: 27px; 
    height: 39px;
    margin-left: 20px;
    margin-top: -114%;
}

.medal-special {
    width: 27px; 
    height: 39px;
    margin-left: 20px;
    margin-top: -114%;
    visibility: hidden;
}

.upvotes-display {
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 2px;
    padding-bottom:2px;
    margin-top: -127%;
    margin-left: 78%;
    color: #555;
    background-color: #f4f4f4;
    font-size: 14px;
    border: none;
}

.header-section {
    height: 160px;
}

.card-icon {
    width:140px;
    height:70px;
}

.card-img {
    width:100%;
    height:100%;
}

.bottom-panel {
    margin-top:7%;
    margin-bottom:6%;
    margin-left:8%;
    margin-right:8%;
}

.status-text {
    padding-top:20px;
    padding-bottom:20px;
    margin-right:10px;
}

.photo {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    margin-right: 20px;
}

.display-image {
    height: 160px;
    width: 100%;
}

.span-caret {
    margin-left: 6px;
}

</style>
